import React, { useState } from "react";
import { Button, Popover, PopoverBody } from "reactstrap";
import { HexColorPicker } from "react-colorful";

const hexToRgbString = (hex) => {
  // Convert hex to RGB
  if (!hex) return "";

  // Remove # if present
  hex = hex.replace("#", "");

  // Parse hex
  let r = 0, g = 0, b = 0;
  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return `${r}, ${g}, ${b}`;
};

const ColorPickerButton = ({ selectedColor, onColorSelect, label }) => {
  const [color, setColor] = useState(selectedColor || "#ffffff");
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const handleColorSelect = (newColor) => {
    console.log(newColor);
    setColor(newColor);
    onColorSelect(newColor);
  };

  return (
    <div>
      <div>
        <Button
          id="color-picker"
          className="w-100 text-start px-3 py-2 d-flex align-items-center gap-3 border"
          color="light"
          onClick={toggle}
        >
          <div
            className="rounded border"
            style={{
              width: "38px",
              height: "38px",
              backgroundColor: color
            }}
          />
          <div>
            <div className="small text-black">HEX: {color}</div>
            <div className="small text-info" style={{ fontSize: "10px" }}>
              RGB {hexToRgbString(color)}
            </div>
          </div>
        </Button>

        <Popover
          placement="bottom-start"
          isOpen={popoverOpen}
          target="color-picker"
          toggle={toggle}
          className="mt-2"
        >
          <PopoverBody>
            <HexColorPicker color={color} onChange={handleColorSelect} />
          </PopoverBody>
        </Popover>
      </div>
    </div>
  );
};

export default ColorPickerButton;